import { useEffect, useState } from 'react';
import { apiCall } from '../special/apiCall';


const BUSINESS_URL = process.env.REACT_APP_BUSINESS_WEB_URL ? process.env.REACT_APP_BUSINESS_WEB_URL.replace(/\/$/, '') : '';
const SHARED_URL = process.env.REACT_APP_SHARED_API_URL ? process.env.REACT_APP_SHARED_API_URL.replace(/\/$/, '') : '';

export default () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    apiCall(`${SHARED_URL}/navigation/settingsurls?businessWebBaseUrl=${BUSINESS_URL}`).then(data => {      
        if (!data.error){
          // console.log("Data", data);                            
          let products = data.map(entry => ({
                          ...entry,
                          label: entry.displayText,
                          iconCls: entry.icon
                        }));
          

          setProducts(products);
        }            
    });

  }, []);

  return products;
};
